import { useEditorStateContext } from "../../contexts/EditorContext";
import usePath from "../path/usePath";
import useCategories from "../category/useCategories";
function useBlockMove() {

    const { mouse } = useEditorStateContext();

    const { movePaths, setPaths } = usePath();
    
    const {moveCategories} = useCategories();

    const moveBlock = (block, x, y, zoom) => {
        block._x = block.x + (x - mouse.x) / zoom;
        block._y = block.y + (y - mouse.y) / zoom;
        let blockRef = document.getElementById(block.object_id);
        blockRef?.classList.add('grabbed')

        let elements = document.elementsFromPoint(x,  y)
        let category = elements.find((element) => element.classList.contains('category_container'));

        if (category != null) {
            
            category.classList.add("category_hovered")
        }
        else{
            let elements = Array.from(document.getElementsByClassName("category_hovered"));
            elements.map( e => e.classList.remove("category_hovered"))
        }
        if (blockRef != null){
            blockRef.style.transform = "translate3d(" + block._x + "px, " + block._y + "px, 0)"; 
        }
    };

    const moveBlocks = (blocks, x, y, scale) => {

        var paths_to_move = [];
        var categories_to_move = [];
        for(let i = 0; i < blocks.length; i++) {
            const {block, paths_out, paths_in} = blocks[i];
            moveBlock(block, x, y, scale);
            paths_to_move = setPaths(paths_to_move, paths_out, block._x, block._y, 'out');
            paths_to_move = setPaths(paths_to_move, paths_in, block._x, block._y, 'in');
            movePaths(paths_to_move)

            if (block.bot_category_id == null){ // pour les categories
                continue;
            }
            let existingCategory = categories_to_move.find(category => category.category_id === block.bot_category_id); // on verifie si la category du block courant est deja dans la liste de celles a modifie

            if (existingCategory) {
                existingCategory.blocks.push(block); // si c'est le cas on ajoute le block courant
            } 
            else { // sinon on ajoute un objet entiee
                categories_to_move.push({
                    category_id: block.bot_category_id,
                    blocks: [block]
                });
            }

        }
        moveCategories(categories_to_move);

    }
    
    return { moveBlocks };
}

export default useBlockMove;
